import { Box, Globe, Hash, Link, Server, Terminal, User } from '@bloo-team/ui/icons'
import type { IconComponent } from '@bloo-team/ui/icons'

const ENTITY_ICON: Record<string, IconComponent> = {
  host: Server,
  user: User,
  ip: Globe,
  hash: Hash,
  url: Link,
  process: Terminal,
}

/** Entity-type pictogram (host, user, ip, hash, url, process; anything else a box). */
export function entityIcon(type: string): IconComponent {
  return ENTITY_ICON[type.toLowerCase()] ?? Box
}
